import script from "./KnowlegeCategoriesList.vue?vue&type=script&setup=true&lang=ts"
export * from "./KnowlegeCategoriesList.vue?vue&type=script&setup=true&lang=ts"

import "./KnowlegeCategoriesList.vue?vue&type=style&index=0&id=14dc1365&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-14dc1365"]])

export default __exports__